const EN = Object.freeze({
  default: true,
  value: 'en',
  text: 'English',
  label: 'EN',
  flag: 'gb',
});

const IT = Object.freeze({
  default: false,
  value: 'it',
  text: 'Italiano',
  label: 'IT',
  flag: 'it',
});

export default Object.freeze([EN, IT]);
